<template>
    <div class="mt-3 mb-2 ml-3 pt-2">
        <div v-for="(sibling, index) in siblings">
            <div class="layout row mb-2">
                <div
                    class="width-200 layout row pl-2"
                    v-if="sibling.name"
                    style="padding-top: 12px !important;"
                >
                    <div class="font-weight-medium mr-2">
                        Name:
                    </div>
                    <div>{{ sibling.name }}</div>
                </div>
                <div
                    class="width-150 layout row pl-2 pt-0"
                    style="margin-bottom: 7px;"
                >
                    <div class="font-weight-medium mr-2">
                        Age:
                    </div>
                    <div>{{ sibling.age }}</div>
                </div>
                <!-- <div class="ml-5">{{ sibling.nameRecordingURL }}</div> -->
                <audio
                    v-if="sibling.nameRecordingURL"
                    class="mb-1"
                    style="height: 25px"
                    controls
                    :src="sibling.nameRecordingURL"
                ></audio>
            </div>
            <v-divider
                class="pt-3 pb-1"
                v-if="index + 1 < siblings.length"
                :key="index"
            ></v-divider>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            siblings: [],
        };
    },
    async created() {
        await this.loadSiblings();
    },
    computed: {},
    methods: {
        async loadSiblings() {
            const siblings = await this.$http.get(
                "api/FoodDistributionAccountInfo/GetSiblings?callUUID=" +
                    this.row.callUUID
            );

            this.siblings = siblings;
        },
    },
};
</script>
<style></style>
